(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.product-gallery')) return;

    const handle = document.querySelector('variant-picker')?.getAttribute('handle');
    if (!handle) return;

    var currentColor = null;
    var colorMediaIds = {};
    var colorFirstIndex = {};

    fetch('/products/' + handle + '.js')
      .then(r => r.json())
      .then(function (product) {

        const colorStartPos = {};
        product.variants.forEach(function (v) {
          if (v.featured_media && !colorStartPos[v.option1]) {
            colorStartPos[v.option1] = v.featured_media.position;
          }
        });

        const colorOrder = Object.entries(colorStartPos)
          .sort((a, b) => a[1] - b[1]);

        colorOrder.forEach(function ([color, startPos], i) {
          const endPos = colorOrder[i + 1]
            ? colorOrder[i + 1][1] - 1
            : Infinity;
          colorMediaIds[color] = new Set(
            product.media
              .filter(m => m.position >= startPos && m.position <= endPos)
              .map(m => String(m.id))
          );
          // Index de la premiere image de cette couleur dans le tableau product.media
          colorFirstIndex[color] = product.media.findIndex(m => m.position === startPos);
        });

        function filterGallery(color) {
          currentColor = color;
          const validIds = colorMediaIds[color];
          if (!validIds) return;

          const slides = document.querySelectorAll('.product-gallery__media');
          const thumbs = document.querySelectorAll('button.product-gallery__thumbnail');

          slides.forEach(function (slide, i) {
            const visible = validIds.has(slide.dataset.mediaId);
            slide.style.display = visible ? '' : 'none';
            if (thumbs[i]) thumbs[i].style.display = visible ? '' : 'none';
          });

          setTimeout(function () {
            var firstVisibleThumb = Array.from(thumbs).find(function (t) {
              return t.style.display !== 'none';
            });
            if (firstVisibleThumb) firstVisibleThumb.click();
          }, 50);
        }

        // Intercepte le bouton zoom — navigue vers le bon index sans cacher les items
        document.addEventListener('click', function (e) {
          var btn = e.target.closest('.circle-button');
          if (!btn) return;
          if (!currentColor) return;

          var targetIndex = colorFirstIndex[currentColor];
          if (targetIndex === undefined || targetIndex < 0) return;

          setTimeout(function () {
            var pswp = document.querySelector('.pswp--open');
            if (!pswp) return;

            // Trouve l'instance PhotoSwipe via le custom element du theme
            var gallery = document.querySelector('product-gallery');
            if (gallery && gallery.pswp && typeof gallery.pswp.goTo === 'function') {
              gallery.pswp.goTo(targetIndex);
              return;
            }

            // Fallback : cherche window.pswp
            if (window.pswp && typeof window.pswp.goTo === 'function') {
              window.pswp.goTo(targetIndex);
            }
          }, 200);
        });

        document.addEventListener('variant:change', function (e) {
          if (e.detail && e.detail.variant && e.detail.variant.option1) {
            filterGallery(e.detail.variant.option1);
          }
        });

        const variantId = new URLSearchParams(window.location.search).get('variant');
        const currentVariant = variantId
          ? product.variants.find(v => String(v.id) === variantId)
          : product.variants[0];
        if (currentVariant) filterGallery(currentVariant.option1);
      });
  });
})();